/* eslint-disable @next/next/no-img-element */
import style from "./style.module.scss";

export const BorderBox = ({ children }: { children: React.ReactNode }) => {
  return <div className={style.borderBox}>{children}</div>;
};
